export const bases = ['CYQM', 'CYFC', 'CYRT', 'CYTH', 'CYXU']
